export default __webpack_public_path__ + "static/media/PlayH5.9b3e9313.png";